import React from 'react';
import { Switch, SwitchProps } from '@mui/material';
import { CustomTooltip } from '@AMIEWEB/Common';
import { useSubmissionPauseToggleAccess } from './useSubmissionPauseToggleAccess';

export interface SubmissionPausedToggleSwitchProps extends Omit<SwitchProps, 'checked' | 'onChange'> {
  isSubmissionPaused: boolean;
  checked: boolean;
  onChange: (checked: boolean) => void;
  externallyDisabled?: boolean;
}

export const SubmissionPausedToggleSwitch = ({
  isSubmissionPaused,
  checked,
  onChange,
  externallyDisabled = false,
  disabled,
  ...switchProps
}: SubmissionPausedToggleSwitchProps) => {
  const { canToggle, tooltipContent, showPermissionTooltip } = useSubmissionPauseToggleAccess(isSubmissionPaused);
  const isDisabled = externallyDisabled || disabled || !canToggle;

  const switchControl = (
    <Switch
      {...switchProps}
      checked={checked}
      onChange={(_event, value) => {
        if (!isDisabled) {
          onChange(value);
        }
      }}
      disabled={isDisabled}
    />
  );

  if (!showPermissionTooltip || !tooltipContent) {
    return switchControl;
  }

  return (
    <CustomTooltip
      standardMargin
      isStandardContent
      disabled={!showPermissionTooltip}
      tooltipContent={tooltipContent}
      placement="bottom-start"
      arrow={false}
    >
      <span>{switchControl}</span>
    </CustomTooltip>
  );
};
